import React, { createContext, useContext, useState, useMemo } from 'react';

export type AppVariant = 'a' | 'b';

const STORAGE_KEY = 'ui-variant';

interface VariantContextValue {
  variant: AppVariant;
  setVariant: (v: AppVariant) => void;
}

const VariantContext = createContext<VariantContextValue>({
  variant: 'b',
  setVariant: () => {},
});

export const useVariant = () => useContext(VariantContext);

export const VariantProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [variant, setVariantState] = useState<AppVariant>(
    () => (localStorage.getItem(STORAGE_KEY) as AppVariant) || 'b',
  );

  const value = useMemo(
    () => ({
      variant,
      setVariant: (v: AppVariant) => {
        localStorage.setItem(STORAGE_KEY, v);
        setVariantState(v);
      },
    }),
    [variant],
  );

  return <VariantContext.Provider value={value}>{children}</VariantContext.Provider>;
};
